"use client"

import { useCallback } from "react"
import devDebug from "../lib/utils/dev-debug"

export function useTrackInteraction() {
  // Remove the try/catch block and simplify the trackInteraction function
  // to ensure no errors are ever shown to the user

  const trackInteraction = useCallback((perfilId: string, component: string, slug: string) => {
    const yyyymm = new Date().toISOString().slice(0, 7).replace("-", "")
    // console.log("trackInteraction", perfilId, component, yyyymm)

    // Fire and forget - don't handle errors on client side
    fetch("/api/track", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        perfilId,
        component,
        yyyymm,
        slug
      }),
      keepalive: true,
    }).catch(() => {
      devDebug.error("Error tracking interaction")
    })

    return true // Always return true regardless of actual success
  }, [])

  return { trackInteraction }
}

